export const environment = {
  production: true,
  disableAds: false,
  mediaBaseUrl: '',
  baseUrl: 'https://www.ctidoma.cz',
  contentApiHost: typeof window === 'undefined' ? 'http://frontend-proxy:8080/api' : '/api',
  redisHost: 'frontend-redis:6379',
};
